import {useState} from 'react';
import ArrCheckboxList from '../../../components/common/arr-checkbox-list/ArrCheckboxList';

const CheckboxListDemo = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [checked, setChecked] = useState<boolean[]>([]);
  const options = [
    {
      label: 'Document',
      value: false,
    },
    {
      label: 'Email',
      value: false,
    },
    {
      label: 'No Data',
      value: false,
    },
    {
      label: 'Other Documents',
      value: false,
    },
    {
      label: 'Presentation',
      value: false,
    },
    {
      label: 'Spreadsheet',
      value: false,
    },
  ];

  return (
    <>
      <ArrCheckboxList
        parentLabel="Select All"
        childLabels={options}
        onChange={(value) => setChecked(value)}
        size="small"
      />
    </>
  );
};

export default CheckboxListDemo;
